import {createSlice} from "@reduxjs/toolkit"
import { RootState } from "../DashboardStore"
import { DarkTheme, LightTheme } from "styled-components"
import { darkTheme, lightTheme } from "../../ColorPallette/Theme"

interface ThemeState {
    theme: LightTheme | DarkTheme
    windowSize: string
}

const initialState: ThemeState = {
    theme: darkTheme,
    windowSize: '100%'
}

export const ThemeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers : {
        swapTheme: (state) => {
            if(state.theme.colors.background === darkTheme.colors.background){
                state.theme = {...lightTheme}
            }else if(state.theme.colors.background === lightTheme.colors.background){
                state.theme = {...darkTheme}
            }
        },
        setWindowSize: (state, action) => {
            if(action.payload <= state.theme.breakpoint){
                state.windowSize = '100vw';
            }else if(action.payload > state.theme.breakpoint){
                state.windowSize = '100%';
            }
        }
    }
})

export const {swapTheme, setWindowSize} = ThemeSlice.actions;
export const selectActiveTheme = (state:RootState) => state.theme.theme
export const selectWindowSize = (state:RootState) => state.theme.windowSize
export default ThemeSlice.reducer;